export const sliderV6 = {
  elements: Array.from(
    document.querySelectorAll(".slider--v6 .swiper-container")
  ),
  details: (el) => {
    const isHero = !!+el.dataset.hero;

    return {
      // Optional parameters
      // cssMode: true,
      loop: isHero,
      autoplay: isHero,
      slidesPerView: 1,
      // spaceBetween: 20,
      speed: 1000,
      threshold: 1,
      // longSwipesRatio: 2,
      resistance: false,

      // Disable preloading of all images
      // preloadImages: false,
      // Enable lazy loading
      lazy: true,

      // If we need pagination
      pagination: {
        el: el.querySelector(".swiper-pagination"),
      },
      // Navigation arrows
      navigation: {
        nextEl: el.querySelector(".swiper-button-next"),
        prevEl: el.querySelector(".swiper-button-prev"),
      },
      // breakpoints: {
      //   1023: {
      //     slidesPerView: 2,
      //     spaceBetween: 40,
      //   },
      //   640: {
      //     slidesPerView: 1,
      //     spaceBetween: 20,
      //   },
      // },
    };
  },
};
